var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhatsappIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.94939 20.7399C7.73048 20.6299 7.49016 20.592 7.25179 20.6484C6.44132 20.8391 5.13368 21.1651 4.18213 21.4044C3.64117 21.5406 3.14886 21.059 3.27437 20.5161C3.5108 19.4906 3.83868 18.0643 3.99435 17.3511C4.043 17.1293 4.01284 16.9006 3.91652 16.6953C3.34637 15.4743 3 14.1229 3 12.7033C3 7.19158 8.02139 2.79579 13.7151 3.86409C17.2926 4.53542 20.1677 7.41146 20.839 10.988C21.9073 16.6817 17.5115 21.7031 11.9998 21.7031C10.59 21.7031 9.18115 21.3626 7.94939 20.7399Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.60085 9.16394C7.2144 10.5572 8.26518 12.7706 10.1138 14.6192C11.9624 16.4679 14.1408 17.4836 15.5341 16.0972L15.6625 15.9687C16.221 15.4112 16.1393 14.484 15.4923 14.0326C15.2831 13.8876 15.0642 13.7339 14.8316 13.5714C14.3286 13.2182 13.6407 13.2727 13.2058 13.7056L12.9704 13.9392C11.9575 13.3359 11.4438 12.756 10.7598 11.7286L10.9933 11.4932C11.4253 11.0573 11.4798 10.3694 11.1276 9.86641C10.9641 9.63387 10.8114 9.41496 10.6655 9.20578C10.215 8.55877 9.28775 8.47801 8.72928 9.03551L8.60085 9.16394Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappIcon);
export default __webpack_public_path__ + "static/media/whatsapp-icon.958e9572.svg";
export { ForwardRef as ReactComponent };